import {
    infiniteQueryOptions,
    QueryFunctionContext,
    UseInfiniteQueryOptions,
  } from "@tanstack/react-query";
import { fetchCustomPaginatedGraphQL } from "./fetchCustomPaginatedGraphQL";
  
  export type PaginatedResponse<T> = {
    items: T[];
    nextToken?: string | null;
    pages?: PaginatedResponse<T>[];
  };
  
  type CreateCustomPaginatedQueryOptionsProps<T> = {
    queryKey: any[];
    graphqlQuery: string;
    getVariables: (pageParam: string | undefined) => Record<string, any>;
    options?: Partial<
      UseInfiniteQueryOptions<
        PaginatedResponse<T>,
        Error,
        PaginatedResponse<T>,
        any[],
        string | undefined
      >
    >;
  };
  
  export function createCustomPaginatedQueryOptions<T>({
    queryKey,
    graphqlQuery,
    getVariables,
    options = {},
  }: CreateCustomPaginatedQueryOptionsProps<T>) {
    return infiniteQueryOptions<
      PaginatedResponse<T>,
      Error,
      PaginatedResponse<T>,
      any[],
      string | undefined
    >({
      queryKey,
      queryFn: (ctx: QueryFunctionContext<any[], string | undefined>) => {
        return fetchCustomPaginatedGraphQL<T>(graphqlQuery, getVariables(ctx.pageParam));
      },
      getNextPageParam: (lastPage) =>
        lastPage.items?.length > 0 && typeof lastPage.nextToken === "string"
          ? lastPage.nextToken
          : undefined,
      initialPageParam: undefined,
      ...options,
    });
  }
  